
import { Getter, State } from 'vuex-class';
import { Component, Vue } from 'vue-property-decorator';
import CardSection from "@/components/shared/CardSection.vue";
import SaveToolbar from '@/components/shared/SaveToolbar.vue';

@Component({
  components: {
    CardSection,
    SaveToolbar
  }
})
export default class MedicalHistory extends Vue {  
  title = 'Health Insurance';
}
